import Reveal from '@/components/base/Reveal';
import { latestList } from '@/mocks/home';

export default function LatestSection() {
  return (
    <section id="latest" className="w-full bg-background-50 py-20 md:py-28">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-4 border-b border-background-300/70 pb-6 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <div className="flex items-center gap-2 text-[12px] tracking-[0.28em] text-primary-600">
                <span className="h-px w-6 bg-primary-500" />
                02 / 更新流
              </div>
              <h3 className="mt-3 font-heading text-[30px] font-black tracking-tight text-foreground-950 md:text-[40px]">
                最新爆料
              </h3>
              <p className="mt-2 max-w-[560px] text-[14px] leading-relaxed text-foreground-600">
                标题与要点优先呈现，公开不限量，无需付费即可逐条查看，热门条目会持续追加跟进。
              </p>
            </div>
            <div className="flex shrink-0 items-center gap-2 text-[13px] text-foreground-500">
              <span className="flex h-4 w-4 items-center justify-center text-primary-500">
                <i className="ri-pulse-line text-[16px]" />
              </span>
              刚刚更新
            </div>
          </div>
        </Reveal>

        <div className="mt-8 flex flex-col">
          {latestList.map((item, index) => (
            <Reveal key={item.id} delay={index * 40}>
              <article className="group grid grid-cols-1 gap-5 border-b border-background-200 py-7 md:grid-cols-[200px_1fr] md:gap-8">
                <div className="h-[180px] w-full overflow-hidden rounded-lg border border-background-200 bg-background-100 md:h-[132px]">
                  <img
                    src={item.cover}
                    alt={`${item.title} 配图`}
                    title={`黑料免费 · ${item.tag}爆料`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                </div>
                <div className="flex min-w-0 flex-col justify-center">
                  <h4 className="font-heading text-[19px] font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-[22px]">
                    {item.title}
                  </h4>
                  <p className="mt-2.5 line-clamp-2 text-[14px] leading-relaxed text-foreground-600">
                    {item.summary}
                  </p>
                  <div className="mt-4 flex flex-wrap items-center gap-2 md:gap-4">
                    <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-[12px] text-accent-900">
                      {item.tag}
                    </span>
                    <span className="flex items-center gap-1 text-[12px] text-foreground-500">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-time-line text-[13px]" />
                      </span>
                      {item.time}
                    </span>
                    <span className="flex items-center gap-1 text-[12px] text-foreground-500">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-fire-line text-[13px]" />
                      </span>
                      热度 {item.heat}
                    </span>
                    <span className="ml-auto hidden items-center gap-1 text-[13px] font-medium text-primary-600 sm:flex">
                      继续看
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-arrow-right-line text-[15px]" />
                      </span>
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-10 flex justify-center">
            <button
              type="button"
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-8 py-3 text-[14px] font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              展开更多爆料条目
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}